import { NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';

import { MessagesModule }      from '../../app-lite/messages/messages.module';
import { SharedModule }        from '../../app-lite/shared/shared.module';
import { UserService }         from './user.service';
import { UserSignUpComponent } from './user.sign-up.component';
import { UsersStates }         from './users.states';
import { VerifyUserComponent } from './user.verify.component';

@NgModule({
  declarations: [
    UserSignUpComponent,
    VerifyUserComponent
  ],
  imports: [
    UIRouterModule.forChild({ states: UsersStates }),

    MessagesModule,
    SharedModule
  ],
  providers: [
    UserService
  ]
})
export class UsersModule {}
